import * as Common from '@/tenant/common';
import { StockTransfer } from '../Transaction/StockTransfer';
import { StockRelocation } from '../Transaction/StockRelocation';

export class StockBalance extends Common.ObjectBase{
  constructor(){
    super('StockBalance')
    this.binders.stockKey = new Common.ModelBinder(Common.StockKey);
  }

  public id: number = 0;
  public keyId: number = 0;
  public stockKey: Common.StockKey = null;
  public stockPricingId: number = null; 
  public stockPricing: Common.StockPricing = null; 
  public closingDate: Date = new Date().getCalendarDate();
  public nextId: number = null; 
  public referenceCount: number = null; 
  
  // 実在庫
  public beginningStockQuantity: number = 0;
  public beginningStockPricingId: number = null;
  public beginningStockPricing: Common.StockPricing = null;
  public beginningStockAmount: number = 0;
  public purchaseQuantity: number = 0;
  public purchaseAmount: number = 0;
  public salesQuantity: number = 0;
  public salesAmount: number = 0;
  public withDrawAmount: number = 0;
  public stockQuantity:number = 0;
  // 積送品・未着品
  public beginningConsignmentQuantity: number = 0;
  public beginningConsignmentAmount: number = 0;
  public consignmentQuantity: number = 0;
  public consignmentAmount: number = 0;
  public beginningUndeliveredQuantity: number = 0;
  public beginningUndeliveredAmount: number = 0;
  public undeliveredQuantity: number = 0;
  public undeliveredAmount: number = 0;
  public totalConsignmentAmount:number = 0;
  public stockPrice:number = 0;
  public stockAmount:number = 0;
  public beginningTotalStockQuantity:number = 0;
  public beginningTotalStockAmount:number = 0;  
  // 予定在庫
  public beginningSchedulePurchaseQuantity: number = 0;
  public schedulePurchaseQuantity: number = 0;
  public beginningScheduleSalesQuantity: number = 0;
  public scheduleSalesQuantity: number = 0;
  public scheduleStockQuantity: number = 0;

  // 引当処理用
  public availableAllocationQuantity: number = 0;
  public allocationQuantity: number = 0;
  public scheduledDeliveryDate: Date = null;

  // 在庫移動用
  public stockRelocationQuantity: number = 0;

  // 棚卸処理用
  public physicalStockQuantity: number = 0;
  public lossStockQuantity: number = 0;

  //移行数量・金額
  public migrationQuantity:number = 0;
  public migrationAmount:number = 0;

  public get quantityScale():number{
    return this.stockKey && this.stockKey.commodity ? this.stockKey.commodity.quantityScale : 0;
  }
  public get priceScale():number {
    return this.stockKey && this.stockKey.commodity ? this.stockKey.commodity.stockPriceScale : 0;    
  }
}

export class StockBalanceQuery extends Common.LoadQuery {
  constructor(){
    super('StockBalanceQuery',StockBalance);
    this.sort = 'segment';
  }

  public closingDate: Date = new Date().getCalendarDate();
  public segment: Common.Segment = null;
  public warehouse: Common.Counterpart = null;
  public projectItem: Common.ProjectItem = null;  
  public projectItemNo: string = null;    
  public excludeProject : boolean = false;
  public commodity: Common.Commodity = null;
  public sku: Common.SKU = null;
  public codeNameModel: string ='';
  public commodityCategory1: number = null;
  public commodityCategory2: number = null;
  public commodityCategory3: number = null;
  public commodityCategory4: number = null;
  public commodityCategory5: number = null;
  public commodityCategory6: number = null;
  public reserveText1: string = '';
  public reserveText2: string = '';
  public reserveText3: string = '';
  public reserveText4: string = '';
  public reserveText5: string = '';
  public reserveText6: string = '';
  public reserveMemo1: string = '';
  public reserveMemo2: string = '';
  public reserveMemo3: string = '';
  public reserveDate1From: Date = null;
  public reserveDate1To: Date = null;
  public reserveDate2From: Date = null;
  public reserveDate2To: Date = null;
  public reserveDate3From: Date = null;
  public reserveDate3To: Date = null;
  public reserveList1: number = null;
  public reserveList2: number = null;
  public reserveList3: number = null;
  public assembly: Common.Assembly = null;
  public requiredWarehouse:boolean = false;
  public noDifferenceFlag: boolean = true;
}

export class StockBalanceAllocateQuery extends Common.LoadQuery {
  constructor(){
    super('StockBalanceAllocateQuery',StockBalance);
    this.sort = 'id';
  }

  public orderItem: Common.OrderItem = null;
}

export class StockBalanceDetailQuery extends Common.LoadQuery {
  constructor(){
    super('StockBalanceDetailQuery',StockBalance);
  }

  public stockBalance: Common.StockBalance = null;
  public amountFlag: boolean = false;
}

export class StockPricingDetailQuery extends Common.LoadQuery {
  constructor(){
    super('StockPricingDetailQuery',StockBalance);
  }

  public stockBalance: Common.StockBalance = null;
}

export class CreateStockRelocationQuery extends Common.Query {
  constructor(){
    super('CreateStockRelocationQuery',new Common.ModelBinder(StockRelocation,false));
  }
  public pic: string;
  public warehouseIn: Common.Counterpart;
  public bookDate: Date;
  public workflowId:number = 0;  
  public actionId:number = 0;
  public stockBalances: Array<Common.StockBalance>;
  public stockRelocation: Common.StockRelocation = null;
}

// セット組立-組立可能数量取得
export class StockAssemblyQuery extends Common.Query {
  constructor(){
    super('StockAssemblyQuery',new Common.ModelBinder(Common.Component,false));
  }
  public assembly: Common.Assembly;
  public stockBalances: Array<Common.StockBalance>;
}

// セット組立-組立元の振替一覧取得
export class StockTransferItemOutQuery extends Common.Query {
  constructor(){
    super('StockTransferItemOutQuery',new Common.ModelBinder(Common.StockTransferItem,true));
  }
  public assembly: Common.Assembly;
  public assemblyQuantity: number;
  public stockBalances: Array<Common.StockBalance>;
}

// セット分解-サーバチェック実行
export class StockDivideQuery extends Common.Query {
  constructor(){
    super('StockDivideQuery',new Common.ModelBinder(Common.Assembly,false));
  }
  public stockBalance: Common.StockBalance;
}

// セット分解-分解後の振替一覧取得
export class StockTransferItemInQuery extends Common.Query {
  constructor(){
    super('StockTransferItemInQuery',new Common.ModelBinder(Common.StockTransferItem,true));
  }
  public assembly: Common.Assembly;
  public assemblyQuantity: number;
  public segment: Common.Segment;
}

export class CreateStockTransferQuery extends Common.Query {
  constructor(){
    super('CreateStockTransferQuery',new Common.ModelBinder(StockTransfer,false));
  }
  public transferFlag: number;
  public pic: string;
  public bookDate: Date;
  public refNo: string;
  public closingDate: Date;
  public segmentOut: Common.Segment;
  public warehouseOut: Common.Counterpart;
  public segmentIn: Common.Segment;
  public warehouseIn: Common.Counterpart;
  public workflowId:number = 0;
  public actionId:number = 0;
  public stockTransferItemsOut: Array<Common.StockTransferItem>;
  public stockTransferItemsIn: Array<Common.StockTransferItem>;
  public stockTransfer: Common.StockTransfer;
}

export class CheckStockTakingQuery extends Common.Query {
  constructor(){
    super('CheckStockTakingQuery',new Common.ModelBinder(StockBalance,false));
  }
  public stockBalances: Array<Common.StockBalance>;
}

export class CreateStockTakingQuery extends Common.Query {
  constructor(){
    super('CreateStockTakingQuery',new Common.ModelBinder(Common.StockTaking,false));
  }
  public pic: string;
  public bookDate: Date;
  public refNo: string;
  public barcodeInspection:boolean;
  public workflowId:number = 0;
  public actionId:number = 0;
  public stockBalances: Array<Common.StockBalance>;
  public stockTaking: Common.StockTaking;
}

export class StockTakingExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery){
    super("",loadQuery);
    this.className = "StockTakingExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
  }
  public loadQuery : Common.LoadQuery;
  public sheetName  :string;
}

export class StockTakingImportQuery extends Common.ImportQuery {
  constructor(sheetName:string){
    super("",null);
    this.className = "StockTakingImportQuery";
    this.sheetName = sheetName;
  }
  public sheetName  :string;
}

export class MigrationExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery){
    super("",loadQuery);
    this.className = "MigrationExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
  }
  public loadQuery : Common.LoadQuery;
  public sheetName  :string;
}


export class StockBalanceExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery){
    super("",loadQuery);
    this.className = "StockBalanceExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
  }
  public loadQuery : Common.LoadQuery;
  public sheetName  :string;
}

export class MigrationImportQuery extends Common.ImportQuery {
  constructor(sheetName:string){
    super("",null);
    this.className = "MigrationImportQuery";
    this.sheetName = sheetName;
  }
  public sheetName  :string;
}